import { apolloClient } from '~/apollo-client';
import { FETCH_SCRAPER_DETAILS_VALIDITY } from './fetch-scraper-details-validity.queries';

export const fetchScraperDetailsValidity = async (
  params: FetchScraperDetailsValidityParams,
): Promise<FetchScraperDetailsValidityResponse> => {
  const { data } = await apolloClient.query({
    query: FETCH_SCRAPER_DETAILS_VALIDITY,
    variables: { utilityAccountId: params.utilityAccountId },
    fetchPolicy: 'no-cache',
  });
  return data;
};

export interface FetchScraperDetailsValidityParams {
  utilityAccountId: number | undefined;
}

export interface FetchScraperDetailsValidityResponse {
  utilityAccount: {
    hasInValidScraperDetails: boolean;
  };
}
